import React, { Component } from 'react';
import moment from 'moment';
import axios from './../../axios';
import * as  url from './../../utils/url';
import EnterpriseBreadcrumb from '../../../src/components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';
import { connect } from 'react-redux';
import Loading from '../../hoc/Loading/Loading';


class ImportHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            history:[]
        };
    }


    componentDidMount(){
        axios.get(url.getImports).then(({ data }) => {
            console.log("data---", data.data)
            let result = data.data
            this.setState({
              history: [...result],
            });
          });
    }

    navigateToUploadData = () => {
        if(this.props.user.orgAdmin) {
          this.props.history.push('/home/upload-data');
        } 
        // else {
        //   this.props.history.push('/home/upload-data/manual');
        // }
      }

    

    renderList = (list) => {
        if (list && list.length > 0) {
            return list.map((item, index) => (
                
                <tr key={index}>
                
                    {/* <td>{this.getUserName(item)}</td> */}
                    <td>{item.name?item.name:`File Uploaded: ${moment(item.timestamp).format('MM/DD/YYYY')}`}</td>
                    {/* <td>{moment(item.timestamp).format('MM/DD/YYYY')}</td> */}
                    <td>{moment(item.timestamp).format("MM/DD/YYYY, h:mm:ss a")}</td>

                    <td>{moment(item.uploadDate).format('MM/DD/YYYY')}</td>
                    <td>{ item.recordCount }</td>
                    <td>{ item.importType }</td>
                    {/* matchedColumn */}
                    <td>{ item.matchedColumns.map(e=> {
                        return(
                            <p key={e._id_}>
                                {e.key} mapped
                            </p>
                        )
                        
                    }) }</td>
                </tr>
            ));
        }
        return <tr><td>No imports founds. {this.props.user.orgAdmin? <span> Please <span onClick={this.navigateToUploadData}> click here </span> to upload data.</span>:null}</td></tr>;
    };
   
    
    render() {
        let{history}=this.state
        

        console.log(this.props)
        return (
            <div className="ent-settings-data-history">    
                   <EnterpriseBreadcrumb 
          top={'mt60'}
          linkText="Enterprise Management" 
          link="/home/enterprise-info" 
          activeText="Import Data History"
          {...this.props}
          />

                 <div className="mt30">
          <div className="title-text">
            Import Data History
          </div>
        </div>
        <hr/>
        <div className="mt40 mb10 org-chart-description-text">
         See a list of your organization's data import history. 
  
        </div>
               <div>
                    <div className="row p-0 m-0 mt-3 mb-2 table-responsive-sm table-ellipsis">
                        <table className="toolkit-list table text-primary-color tool-list-font" style={{ borderTop: '0px' }}>
                            <thead>
                                <tr className="col-sm-4 mb-3">
                                    <th scope="col" className="bottom-border-color borderTop0"><span className="table-sort-title">File Name</span></th>
                                    <th scope="col" className="bottom-border-color borderTop0"><span className="table-sort-title">Timestamp</span></th>
                                    <th scope="col" className="bottom-border-color borderTop0"><span className="table-sort-title">Selected Date</span></th>
                                    <th scope="col" className="bottom-border-color borderTop0"><span className="table-sort-title">Number of Records Uploaded</span></th>
                                    <th scope="col" className="bottom-border-color borderTop0"><span className="table-sort-title">Import Type</span></th>
                                    <th scope="col" className="bottom-border-color borderTop0"><span className="table-sort-title">Mapped values</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                { this.renderList(history) }
                            </tbody>
                        </table>
                    </div>
                    {/* <If condition={size(userAnalytics) > 0}>
                        <Paginations
                            currentPage={currentPage}
                            totalPageNumber={totalPageNumber}
                            handlePageNavigation={this.handlePageNavigation}
                            Analytics={userAnalytics}
                            generatePageNumbers={this.generatePageNumbers}
                            handleRecordCountChange={this.handleRecordCountChange}
                            recordCount={recordCount}
                            totalRecords={size(userAnalytics)}
                        />
                    </If> */}
                </div>
                
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
      user : state.user,

    }
  }
  
export default connect(mapStateToProps)(Loading(ImportHistory,axios));
